import { useEffect } from "react";

let lockCount = 0;
let originalBodyOverflow = "";
let originalHtmlOverflow = "";
let originalBodyPaddingRight = "";
let originalScrollY = 0;

export const useScrollLock = (isOpen) => {
  useEffect(() => {
    if (isOpen) {
      lockCount++;

      if (lockCount === 1) {
        const body = document.body;
        const html = document.documentElement;
        originalBodyOverflow = body.style.overflow;
        originalHtmlOverflow = html.style.overflow;
        originalBodyPaddingRight = body.style.paddingRight;
        originalScrollY = window.scrollY;

        const scrollbarWidth = window.innerWidth - html.clientWidth;

        html.style.overflow = "hidden";
        body.style.overflow = "hidden";

        if (scrollbarWidth > 0) {
          const computedPadding = parseInt(
            window.getComputedStyle(body).paddingRight,
            10,
          );
          body.style.paddingRight = `${computedPadding + scrollbarWidth}px`;
        }
      }

      return () => {
        lockCount--;

        if (lockCount === 0) {
          document.body.style.overflow = originalBodyOverflow;
          document.documentElement.style.overflow = originalHtmlOverflow;
          document.body.style.paddingRight = originalBodyPaddingRight;
          window.scrollTo(0, originalScrollY);
        }
      };
    }
  }, [isOpen]);
};

export default useScrollLock;
